import { atom } from 'jotai';

export interface Toastr {
  title: string;
  color: string;
  message: string;
  duration: number | null;
  messagePayload: Record<string, any> | null;
  shown?: boolean;
}

export const toastrAtom = atom<Toastr | null>(null);
